import template from './admin-hotel-view.html';
import {adminStates} from './../admin-routes';

const DIRECTIVE_NAME = AdminHotelView.DIRECTIVE_NAME = 'ktAdminHotelView';
export default function AdminHotelView() {
    return {
        restrict: 'A',
        scope: {
            hotel: `=${DIRECTIVE_NAME}`,
        },
        controller: AdminHotelViewController,
        controllerAs: 'adminHotelViewCtrl',
        template,
        bindToController: true,
        link: function($scope, elem, attrs, adminHotelViewCtrl) {
            adminHotelViewCtrl.$onInit();
        },
    };
}

export function AdminHotelViewController(
    $state,
    $stateParams,
    adminHotelViewService
) {
        'ngInject';
        const vm = this;
        const NO_DATA_FROM_SUPPLIERS = 'No data from suppliers';
        const MINIMUM_AMOUNT_OF_HOTELS_TO_SHOW_MERGE_BUTTON = 2;

        Object.assign(vm, {
            $onInit,
            getHotelAddress,
            getHotelCoordinates,
            navigateToHotelEditPage,
            isRatingProvided,
            unmergeHotels,
            isUnmergeHotelsBtnVisible,
            NO_DATA_FROM_SUPPLIERS,
        });

        function $onInit() {
            vm.hotelId = $stateParams.hotelId;
        }

        function getHotelAddress() {
            const {address = '', cityName = '', country = ''} = vm.hotel;
            const fullAddress = `${address} ${cityName} ${country}`;
            return fullAddress.trim();
        }

        function getHotelCoordinates() {
            let {latitude = '', longitude = ''} = vm.hotel && vm.hotel.coordinates || {};
            latitude = latitude !== null ? latitude : '';
            longitude = longitude !== null ? longitude : '';
            const fullCoordinates = `${latitude} ${longitude}`;
            return fullCoordinates.trim();
        }

        function navigateToHotelEditPage() {
            const hotelId = vm.hotel.id;
            $state.go(adminStates.HOTEL_EDIT, {hotelId});
        }

        function isRatingProvided() {
            return Number.isInteger(vm.hotel.starsQuantity);
        }

        function unmergeHotels() {
            if (adminHotelViewService.showUnmergeConfirmationDialog()) {
                adminHotelViewService.unmergeHotels(vm.hotel.id)
                    .then(() => $state.go(adminStates.HOTEL_LIST_RESULTS));
            }
        }

        function isUnmergeHotelsBtnVisible() {
            const {suppliers} = vm.hotel;
            return suppliers && suppliers.length >= MINIMUM_AMOUNT_OF_HOTELS_TO_SHOW_MERGE_BUTTON;
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-view/admin-hotel-view-component.js